<template>
  <div>
    <h1 class="text-center mb-2">Courses</h1>
    <Table ref="edTable" :endpoint="endpoint" :tableConfig="tableConfig" />
    <div class="create-course-container">
      <div class="row">
        <div class="small-12 columns">
          <div class="small-4 columns">Name</div>
          <div class="small-8 columns">
            <input v-model="courseName" type="text" class="course-input-box" />
          </div>
          <div class="small-4 columns">Version</div>
          <div class="small-8 columns">
            <input
              v-model="courseVersion"
              type="text"
              class="course-input-box"
            />
          </div>
          <!--  -->
          <div class="small-4 columns">Price</div>
          <div class="small-8 columns">
            <input v-model="price" type="text" class="course-input-box" />
          </div>
          <!--  -->
          <div class="small-4 columns">Is Preassessment Requied</div>
          <div class="small-8 columns">
            <input v-model="coursePreAssessmentRequired" type="checkbox" />
          </div>
          <div class="small-12 columns">
            <button
              class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900"
              style="display:block;margin:auto;margin-top:20px;"
              @click="createCourse()"
            >
              Create Course
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      price: 0,
      courseName: undefined,
      courseVersion: undefined,
      coursePreAssessmentRequired: undefined,
      endpoint: `${siteConfig.siteURL}courses/`,
      tableConfig: [
        {
          header: { textContent: "Course Name", sortingParam: "name" },
          classList: "w-1/4",
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Version" },
          path: "version",
        },
        {
          header: { textContent: "Pre-ass. Required" },
          path: "is_pre_assement_required",
          formatter(data) {
            return data ? "Yes" : "No"
          },
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/course/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
  methods: {
    createCourse() {
      if (this.courseName.length === 0) {
        return
      }
      const dataObj = {}
      dataObj.name = this.courseName
      dataObj.is_pre_assement_required = this.coursePreAssessmentRequired
      dataObj.version = parseInt(this.courseVersion)
      dataObj.base_price = parseInt(this.price)

      this.axios({
        method: "post",
        url: this.endpoint,
        data: dataObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$refs.edTable.getItems()
      })
    },
  },
}
</script>

<style scoped>
.course-input-box {
  width: 94%;
  margin: auto;
  margin-bottom: 15px;
}
.create-course-container {
  width: 90%;
  margin: 2.5rem auto;
  margin-top: 40px;
  padding: 39px;
  padding-top: 50px;
  background-color: #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}
</style>
